module.exports = __webpack_public_path__ + "img/2-2.a405b470.svg";